import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { MutationAddButlerButtonArgs } from '../generated';
import { token } from '@trello/session-cookie';
import { parseNetworkError } from '@trello/graphql-error-handling';
import { ResolverContext } from '../types';

export const addButlerButton = async (
  obj: object,
  args: MutationAddButlerButtonArgs,
  context: ResolverContext,
  info: QueryInfo,
) => {
  // Scope must be 'boards' | 'organizations'.
  const response = await fetch(
    `/1/${args.scope}/${args.idScope}/butlerButtons`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Trello-Client-Version': context.clientAwareness.version,
      },
      body: JSON.stringify({
        ...args.butlerButton,
        token,
      }),
    },
  );

  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  return prepareDataForApolloCache(await response.json(), info);
};
